import { Button } from 'kl-b2c-ui-kit';
import styled from 'styled-components';
import { colorBlack, mediaMd, mediaXs } from 'theme/theme-helper-selectors';

export const Title = styled.h4`
    font-size: 72px;
    line-height: 72px;
    font-weight: 400;
    color: ${colorBlack};
    margin: 0 0 30px 0;

    @media (${mediaXs}) {
        font-size: 32px;
        line-height: 36px;
        margin: 0 0 24px 0;
    }
`;

export const Subtitle = styled.p`
    font-size: 24px;
    line-height: 28px;
    font-weight: 300;
    color: ${colorBlack};
    margin: 0 0 30px 0;

    @media (${mediaXs}) {
        font-size: 19px;
        line-height: 21px;
        margin: 0 0 24px 0;
        font-weight: 300;
    }
`;

export const Container = styled.div`
    width: 594px;
    margin: 0 auto;

    @media (${mediaMd}) {
        width: 475px;
    }

    @media (${mediaXs}) {
        width: initial;
    }
`;

export const SubmitButton = styled(Button)`
    padding: 17px 24px;
    font-size: 21px;
    line-height: 24px;
    min-width: 213px;

    @media (${mediaMd}) {
        font-size: 16px;
        line-height: 20px;
        padding: 14px 24px;
        min-width: 176px;
    }

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 20px;
        padding: 14px 35px;
        width: 100%;
    }
`;
